import { Button, Form, Input, Upload, message } from "antd";
import { PlusOutlined } from '@ant-design/icons';

type FieldType = {
  image: any;
  name: string;
};

const Profile = () => {

  const [form] = Form.useForm()



  const onFinish = async (values: any) => {
    console.log('Success:', values);
  };


  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };


  return (
    <>
      <h1 className="text-base font-medium text-gray-700 mb-4">Хэрэглэгчийн мэдээлэл</h1>
      <div className="bg-white p-4 rounded-xl max-w-[300px] ">
        <Form
          onFinish={onFinish}
          style={{ maxWidth: 600 }}
          form={form}
        >
          <Form.Item<FieldType>
            label="Зураг"
            name="image"
            getValueFromEvent={normFile}>
            <Upload maxCount={1}>
              <button style={{ border: 0, background: 'none' }} type="button">
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </button>
            </Upload>
          </Form.Item>
          <Form.Item<FieldType>
            label="Нэр"
            name="name"
            className='!mb-4'
            rules={[{ message: 'Please input your name!' }]}
          >
            <Input
              placeholder="Нэр"
            />
          </Form.Item>
          <Form.Item >
            <Button className='w-full' type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </>
  )
}

export default Profile